import * as Yup from 'yup';

import { messages } from './parent-account.messages';

// Mirrors the server rule: a contact must keep at least one reachable
// credential. Hangs off both fields so clearing either re-surfaces the error.
const CREDENTIAL_TEST = 'keeps-a-credential';

interface ICredentialSiblings {
  email?: { value?: string } | null;
  phone?: { value?: string } | null;
}

function keepsACredential(this: { parent: ICredentialSiblings }, value?: { value?: string } | null) {
  const { email, phone } = this.parent;
  return !!(value?.value || email?.value || phone?.value);
}

export const validationSchema = Yup.object().shape({
  email: Yup.object()
    .nullable()
    .test(CREDENTIAL_TEST, messages.errKeepOneCredential.defaultMessage, keepsACredential),
  phone: Yup.object()
    .nullable()
    .test(CREDENTIAL_TEST, messages.errKeepOneCredential.defaultMessage, keepsACredential),
});
